var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3v18h18V3zm.313-3c.75 0 1.375.27 1.875.813.541.5.812 1.125.812 1.875v18.625c0 .75-.27 1.395-.813 1.937-.5.5-1.125.75-1.875.75H2.688c-.75 0-1.395-.25-1.937-.75A2.759 2.759 0 010 21.312V2.688c0-.75.25-1.374.75-1.874C1.292.27 1.938 0 2.688 0h18.625z",
    fill: "#3F4E5D"
  })));
}
export default SvgCheckboxEmpty;